/* eslint-disable react/react-in-jsx-scope */
import { Navigate, useLocation } from 'react-router-dom';
import { getAuthItem } from '../../CommonMethods/authSession';

/**
 * ProtectedRoute component that guards routes requiring authentication.
 * 
 * If the user is not authenticated:
 * - Captures the full intended path (pathname + search)
 * - Redirects to /login with the intended path as a URL-encoded `redirect` query parameter
 * 
 * @param {React.ReactNode} children - The child components to render if authenticated
 * @param {boolean} isAuthenticated - Authentication status (passed from parent component)
 */
const ProtectedRoute = ({ children, isAuthenticated }) => {
    const location = useLocation();
    
    // Check authentication via token presence and passed prop
    const hasToken = getAuthItem('IdToken') !== null;
    const authenticated = isAuthenticated && hasToken;

    if (!authenticated) {
        // Capture the full intended path (pathname + search params)
        const intendedPath = location.pathname + location.search;
        
        // Encode the redirect parameter
        const encodedRedirect = encodeURIComponent(intendedPath);
        
        // Redirect to login with the redirect parameter
        return <Navigate to={`/?redirect=${encodedRedirect}`} replace />;
    }

    // User is authenticated, render the protected content
    return children;
};

export default ProtectedRoute;


